import CorporationTable from "components/elements/CorporationTable"
import PageHeader from "components/elements/PageHeader"
import BasePage from "./BasePage"

function BusinessProfilePage() {
    return (
        <>
            {/* {isLoading && <CircleSpinnerOverlay/>} */}
            <PageHeader title={'Business Profile/Account'}/>
            <BasePage>
				<CorporationTable/>
            </BasePage>
        </>
    )
}

export default BusinessProfilePage
